import type {
  TMultipleSelectOption,
  TRankingOption,
  TReusableOption,
  TSingleSelectOption,
} from '@hubertai/screening-question-types';

export function optionExistsById(
  options: (TSingleSelectOption | TMultipleSelectOption | TReusableOption | TRankingOption)[],
  id: string,
) {
  const x = options.filter((o) => 'value' in o && o.value === id);
  if (x.length) return true;
  return false;
}

export const StripHTML = (x: string | string[]): string | undefined => {
  if (typeof x === 'string') {
    return x.replace(/<[^>]*>?/gm, '').replace('&nbsp;', '');
  } else if (Array.isArray(x)) {
    return x
      .join(' ')
      .replace(/<[^>]*>?/gm, '')
      .replace('&nbsp;', '');
  }
};

export function isObject(x: unknown) {
  return x !== undefined && x !== null && x.constructor === Object;
}

export const arrayMove = async (arr: unknown[], oldIndex: number, newIndex: number) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr; // for testing
};

export function makeid(length: number) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) result += characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

export const buildHashedQuestionPath = (nodeId: string, questionPath?: string) => {
  if (questionPath) {
    return `${questionPath}#${nodeId}`;
  }
  return nodeId;
};
